<template>
  <v-col :lg="lg" :md="md"
         cols="12">
    
    <div class="d-flex justify-space-between align-center flex-wrap flex-gap-3">
      <div class="mr-3 valintatyyppi-nimi subtitle-1" :title="valintatyyppi.nimi">{{ valintatyyppi.nimi }}</div>
      <v-btn v-if="$hasEditPermission(vastuualue.id)" color="primary"
             small
             @click="goToNewValinta()">
        <v-icon left>mdi mdi-plus</v-icon>
        {{ $t('valinta.new_valinta') }}
      </v-btn>
    </div>
    <v-divider class="mb-6 mt-2"/>
    <template v-for="valinta in filteredValinnat">
      <valinta-box :key="valinta.id" :valinta="valinta" :vuosi="vuosi"/>
    </template>
  </v-col>
</template>

<script>
import ValintaBox from "@/components/Vastuualue/ValintaBox";

export default {
  name: "ValintatyyppiColumn",
  components: {ValintaBox},
  props: {
    valintatyyppi: Object,
    vastuualue: Object,
    valinnat: Array,
    lg: Number,
    md: Number,
    vuosi: Number
  },
  computed: {
    filteredValinnat() {
      return this.valinnat.filter(valinta => valinta.valintatyyppiId === this.valintatyyppi.id)
    }
  },
  methods: {
    goToNewValinta() {
      this.$router.push({
        name: 'asetukset_valinta_uusi',
        query: {
          vuosi: this.vuosi,
          vastuualueId: this.vastuualue.id,
          valintatyyppiId: this.valintatyyppi.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.flex-gap-3{
  gap: 12px;
}
.valintatyyppi-nimi{
  max-width: calc(100%);
  width:  calc(100%);
  text-overflow: ellipsis;
  overflow:hidden;
  white-space: nowrap;
  
}
</style>